import { LayoutContext } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { useModalView } from '@/design-system/components/modal/useModalView.hook';

import { IssueCardStackRoutes, IssueCardStackScreenProps } from './type';
import { IssueCardWebOneScreen } from './IssueCardWebOne.screen';
import { IssueCardNativeOneScreen } from './IssueCardNativeOne.screen';

export const IssueCardConfirm: React.FC<IssueCardStackScreenProps<IssueCardStackRoutes.Confirm>> = ({ navigation, route }) => {
  const { onLayout, data, account, tab, record, func, onReturnData, refresh, onChangeView } = route.params;
  const layout = useContext(LayoutContext);
  const onGoBack = () => {
    navigation.goBack();
  };
  const { useModalProps, closeModal } = useModalView({});
  if (layout.isMobile) {
    return (
      <IssueCardNativeOneScreen
        onClose={onGoBack}
        onLayout={onLayout}
        data={data}
        account={account}
        tab={tab}
        record={record}
        func={func}
        onReturnData={onReturnData}
        refresh={refresh}
      />
    );
  }

  return (
    <IssueCardWebOneScreen
      onClose={closeModal}
      onLayout={onLayout}
      data={data}
      account={account}
      tab={tab}
      record={record}
      func={func}
      onReturnData={onReturnData}
      refresh={refresh}
      onChangeView={onChangeView}
    />
  );
};
